var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTrackerMovilW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 27,
    viewBox: "0 0 48 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.125 0.25C37.5473 0.25014 37.9343 0.436929 38.1689 0.740234L47.5244 12.8535C47.7874 13.1939 47.8203 13.6306 47.623 13.9951L47.5244 14.1465L38.1689 26.2598C37.9343 26.5631 37.5473 26.7499 37.125 26.75H0.25V0.25H37.125Z",
    fill: "white",
    stroke: "#223D51",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrackerMovilW);
export default __webpack_public_path__ + "static/media/ArrowTrackerMovilW.f76fcd6671cf98fca3385958a036f7d8.svg";
export { ForwardRef as ReactComponent };